import React from 'react';
import { ValidatedField } from 'react-jhipster';
import { Form } from 'reactstrap';
import { Link } from 'react-router-dom';
import { type FieldError, useForm } from 'react-hook-form';
import { colors } from 'app/shared/theme/colors';
import { useTranslation } from 'app/shared/i18n';

export interface ILoginModalProps {
  showModal: boolean;
  loginError: boolean;
  handleLogin: (username: string, password: string, rememberMe: boolean) => void;
  handleClose: () => void;
}

const LoginModal = (props: ILoginModalProps) => {
  const { t } = useTranslation();
  const {
    handleSubmit,
    register,
    formState: { errors, touchedFields },
  } = useForm({ mode: 'onTouched' });
  const login = ({ username, password, rememberMe }) => {
    props.handleLogin(username, password, rememberMe);
  };
  if (!props.showModal) return null;

  return (
    <div className="ms-auth">
      <div className="ms-auth__card ms-card">
        <div className="ms-auth__header">
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 4 }}>
            <div
              style={{
                width: 32,
                height: 32,
                borderRadius: 8,
                background: 'linear-gradient(135deg, #F59E0B, #F97316)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 16,
                fontWeight: 800,
                color: '#000',
              }}
            >
              M
            </div>
            <span style={{ fontSize: 16, fontWeight: 700, color: colors.text }}>
              Mails<span style={{ color: colors.accent }}>Ngon</span>
            </span>
          </div>
          <h2 style={{ fontSize: 18, fontWeight: 700, margin: '8px 0 0' }}>{t('login.title')}</h2>
          <p style={{ fontSize: 13, color: colors.dim, marginTop: 4 }}>{t('login.welcome')}</p>
        </div>
        <div className="ms-auth__body">
          <Form onSubmit={handleSubmit(login)}>
            {props.loginError && (
              <div
                style={{
                  padding: '12px 16px',
                  borderRadius: 10,
                  background: colors.dangerDim,
                  border: `1px solid ${colors.danger}33`,
                  color: colors.danger,
                  fontSize: 13,
                  marginBottom: 16,
                }}
              >
                {t('login.error')}
              </div>
            )}
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', fontSize: 13, fontWeight: 500, color: colors.muted, marginBottom: 6 }}>
                {t('login.usernameLabel')}
              </label>
              <input
                className="ms-input"
                placeholder={t('login.usernamePlaceholder')}
                autoFocus
                data-cy="username"
                {...register('username', { required: t('login.usernameRequired') })}
              />
              {errors.username && (
                <div style={{ fontSize: 12, color: colors.danger, marginTop: 4 }}>{(errors.username as FieldError).message}</div>
              )}
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', fontSize: 13, fontWeight: 500, color: colors.muted, marginBottom: 6 }}>
                {t('login.passwordLabel')}
              </label>
              <input
                className="ms-input"
                type="password"
                placeholder={t('login.passwordPlaceholder')}
                data-cy="password"
                {...register('password', { required: t('login.passwordRequired') })}
              />
              {errors.password && (
                <div style={{ fontSize: 12, color: colors.danger, marginTop: 4 }}>{(errors.password as FieldError).message}</div>
              )}
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
              <label style={{ fontSize: 12, color: colors.muted, display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer' }}>
                <input type="checkbox" defaultChecked {...register('rememberMe')} /> {t('login.rememberMe')}
              </label>
              <Link to="/reset-pass" style={{ fontSize: 12 }}>
                {t('login.forgotPassword')}
              </Link>
            </div>
            <button className="ms-btn ms-btn--primary" type="submit" data-cy="submit" style={{ width: '100%', padding: 12 }}>
              {t('login.submit')}
            </button>
          </Form>
        </div>
        <div className="ms-auth__footer">
          {t('login.noAccount')}{' '}
          <Link to="/account/register" style={{ fontWeight: 600 }}>
            {t('login.register')}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default LoginModal;
